import Vue from 'vue';
import Router from 'vue-router';
import CheckScreen from "@/layout/checkScreen/checkScreen.vue";
import newClt from "@/layout/checkScreen/newClt.vue";
import offlineLayout from "@/layout/checkScreen/layout.vue";
import { getPublicPageMeta, PUBLIC_CATALOG_META, NO_INDEX_META } from "@/helpers/labels";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

import rootLayout from '../layout/rootPanel/SampleLayout.vue';


// Admin pages
const Societes = () => import(/* webpackChunkName: "common" */ "@/pages/societes/index.vue");
const logout = () => import(/* webpackChunkName: "common" */ "@/pages/logout.vue");
const Admins = () => import(/* webpackChunkName: "common" */ "@/pages/admins/index.vue");
const Opts_Grp = () => import(/* webpackChunkName: "common" */ "@/pages/opts_grp/index.vue");
const Cats = () => import(/* webpackChunkName: "common" */ "@/pages/prd_cats/index.vue");

const Prods = () => import(/* webpackChunkName: "common" */ "@/pages/prods/index.vue");
const Cmds = () => import(/* webpackChunkName: "common" */ "@/pages/cmds/index.vue");
const Avoirs = () => import(/* webpackChunkName: "common" */ "@/pages/avoirs/index.vue");
const Factures = () => import(/* webpackChunkName: "common" */ "@/pages/factures/index.vue");
const Devis = () => import(/* webpackChunkName: "common" */ "@/pages/devis/index.vue");
const Ddevis = () => import(/* webpackChunkName: "common" */ "@/pages/ddevis/index.vue");
const Services = () => import(/* webpackChunkName: "common" */ "@/pages/services/index.vue");
const Bons = () => import(/* webpackChunkName: "common" */ "@/pages/bons/index.vue");
const Home = () => import(/* webpackChunkName: "common" */ "@/pages/home/index.vue");

export const ClientRouter = {
  path: '/client',
  name: 'Super admin',
  redirect: '/catalogue',
  component: offlineLayout,

  children: [
    {
      path: '/ddevis',
      name: 'Demandes devis',
      components: { default: Ddevis },
      // props: { default: () => ({ PID: 38 }) }
    },
    {
      path: '/devis',
      name: 'devis',
      components: { default: Devis },
      // props: { default: () => ({ PID: 38 }) }
    },
    

    {
      path: '/cmds',
      name: 'Gestion des achats',
      components: { default: Cmds },
      // props: { default: () => ({ PID: 38 }) }
    },      

    {
      path: '/factures',
      name: 'factures',
      components: { default: Factures },
      // props: { default: () => ({ PID: 38 }) }
    },

    {
      path: '/avoirs',
      name: 'avoirs',
      components: { default: Avoirs },
      // props: { default: () => ({ PID: 38 }) }
    },
    
    {
      path: '/cmds',
      name: 'commandes',
      components: { default: Cmds },
      // props: { default: () => ({ PID: 38 }) }
    },      
    { path: "*", redirect: '/'},
  ]
 
};

export const SuperAdminRouter = {
    path: '/superadmin',
    name: 'Super admin',
    redirect: '/products',
    component: rootLayout,
    meta: {
      title: 'ittec-P&M'
    },
    children: [
      {
        path: '/options',
        name: 'options',
        components: { default: Opts_Grp },
        // props: { default: () => ({ PID: 38 }) }
      },
      {
        path: '/bons',
        name: 'bons de livraison',
        components: { default: Bons },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - bons de livraison'
        },
      },
      {
        path: '/devis',
        name: 'devis',
        components: { default: Devis },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Devis'
        },
      },
      {
        path: '/societes',
        name: 'clients',
        components: { default: Societes },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Sociétés'
        },
      },

      {
        path: '/ddevis',
        name: 'demandes de devis',
        components: { default: Ddevis },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Demandes de devis'
        },
      },

      {
        path: '/factures',
        name: 'factures',
        components: { default: Factures },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Factures'
        },
      },

      {
        path: '/avoirs',
        name: 'avoirs',
        components: { default: Avoirs },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Avoirs'
        },
      },
      
      {
        path: '/cmds',
        name: 'commandes',
        components: { default: Cmds },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Commandes'
        },
      },      
      
      {
        path: '/products',
        name: 'produits',
        components: { default: Prods },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Produits'
        },
      },
      {
        path: '/services',
        name: 'services',
        components: { default: Services },
        // props: { default: () => ({ PID: 38 }) }
      },
      {
        path: '/admins',
        name: 'utilsateurs',
        components: { default: Admins },
        // props: { default: () => ({ PID: 38 }) }
        meta: {
          title: 'ittec-P&M - Services'
        },
      },
      {
        path: 'catalogue',
        name: 'catalogue-admin',
        components: { default: Home },
        props: { default: () => ({ isAdmin: true }) },
        meta: {
          title: 'ittec-P&M - Catalogue'
        },
      },
      
    ]
  };
const routes = [
  {
    path: "/",
    component: offlineLayout,
    redirect: '/catalogue',
    children: [
      {
        path: '/accueil',
        redirect: '/catalogue',
      },
      {
        path: '/catalogue',
        name: 'catalogue',
        components: { default: Home },
        props: { default: () => ({ catalogMode: 'PRD' }) },
        meta: PUBLIC_CATALOG_META,
      },
      {
        path: '/a-propos',
        name: 'a-propos',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'about' }) },
        meta: getPublicPageMeta('about'),
      },
      {
        path: '/nos-services',
        name: 'nos-services',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'services' }) },
        meta: getPublicPageMeta('services'),
      },
      {
        path: '/services/pieces-de-rechange',
        name: 'service-pieces',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'service-parts' }) },
        meta: getPublicPageMeta('service-parts'),
      },
      {
        path: '/services/fourniture-aeroports',
        name: 'service-aeroports',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'service-airports' }) },
        meta: getPublicPageMeta('service-airports'),
      },
      {
        path: '/services/formation-et-conseil',
        name: 'service-formation',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'service-training' }) },
        meta: getPublicPageMeta('service-training'),
      },
      {
        path: '/formations-et-conseils',
        name: 'formations-et-conseils',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'training' }) },
        meta: getPublicPageMeta('training'),
      },
      {
        path: '/contact',
        name: 'contact',
        components: { default: Home },
        props: { default: () => ({ publicPageSlug: 'contact' }) },
        meta: getPublicPageMeta('contact'),
      },
      {
        path: '/inscription',
        name: 'inscription',
        components: { default: newClt },
        props: { default: () => ({ NEW_CLT: true }) },
        meta: {
          title: 'Inscription | ITTEC P&M',
          description: 'Page d inscription ITTEC P&M.',
          ...NO_INDEX_META,
        },
      },
      {
        path: '/authentification',
        name: 'authentification',
        components: { default: CheckScreen },
        props: { default: () => ({}) },
        meta: {
          title: 'Authentification | ITTEC P&M',
          description: 'Page d authentification ITTEC P&M.',
          ...NO_INDEX_META,
        },
      },
      {
        path: '/deconnexion',
        name: 'deconnexion',
        components: { default: logout },
        meta: NO_INDEX_META,
      },
      
    ]
  },
  { path: "*", redirect: '/'},
];

Vue.use(Router);

const router = new Router({routes: routes, mode: 'history'});

router.beforeEach((to, from, next) => {
  const user = Vue.$cookies.get('user');
  const isAdminUser = user && ['ADMIN', 'ROOT', 'COMMERCIAL', 'TECHNIQUE', 'MAGASINIER'].includes(user.type);
  const backofficeOnlyPaths = ['/products', '/societes', '/admins', '/bons', '/options', '/superadmin'];
  const isProtectedServicesRoute = to.path === '/services';

  if (
    isProtectedServicesRoute ||
    backofficeOnlyPaths.some((path) => to.path === path || to.path.startsWith(`${path}/`))
  ) {
    if (!isAdminUser) {
      next('/catalogue');
      return;
    }
  }

  next();
});

export default router;
